//deps
import styled, { StyledComponent } from "styled-components";

//internal-deps
import { AriaHidden, Tooltip } from "@swiggy-private/core-ui";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TurboPaymentCommsType } from "@payment-ui/interfaces/TurboPayment";
import { TooltipProps } from "@payment-ui/widgets/turbo-tooltip/TurboTooltip";

export const CommImgContainer: StyledComponent<typeof AriaHidden, ITheme> = styled(AriaHidden)`
    margin-right: ${(props) => props.theme.spacing.xSmall};
`;

interface ExtendedTooltipProps extends TooltipProps {
    isTurboV2?: boolean;
}

export const TurboPayCommsTooltip: StyledComponent<typeof Tooltip, ITheme, ExtendedTooltipProps> = styled(
    Tooltip,
)<ExtendedTooltipProps>`
    position: absolute;
    left: ${(props) => props.theme.spacing.xSmall};
    bottom: ${(props) => (props.isTurboV2 ? props.theme.spacing.xLarge : "92px")};
    transform: translateY(-120%);
    width: 240px;
    background: ${(props) => props.theme.colors[props.theme.colorMode].background_inverse_Primary};
    z-index: ${(props) => props.theme.elevation[props.theme.colorMode].halfcards_And_Popups.zIndex};

    &::before {
        background: ${(props) => props.theme.colors[props.theme.colorMode].background_inverse_Primary};
    }

    ${({ isTurboV2 }) =>
        isTurboV2 &&
        `
        height: auto;
        transform: translateY(-100%);
        bottom: auto;
    `}
`;

export const TurboPayCommsTooltipContent = styled(Text)<{ commsType: string | null }>`
    margin-right: ${(props) => (props.commsType === TurboPaymentCommsType.OFFER_COMMS ? "16px" : "0px")};
`;
